:root {
  --base: #FFFFFF;
  --cream: #F3F3F3;
  --ink: #0C0C14;
  --ink-2: #16161F;
  --brand: #01007F;
  --brand-hover: #010063;
  --tint: #EEEEF8;
  --text-1: #16161F;
  --text-2: #2A2A34;
  --text-3: #5B5B67;
  --text-4: #8A8A94;
  --line-1: #E2E2E5;
  --line-2: #ECECEE;

  --status-neu-bg: #EEEEF8; --status-neu-fg: #01007F;
  --status-kontaktiert-bg: #FFF4DE; --status-kontaktiert-fg: #9A6A00;
  --status-produktion-bg: #E3F0FF; --status-produktion-fg: #0B63C4;
  --status-erledigt-bg: #EAF7EF; --status-erledigt-fg: #1E9E5A;
  --status-abgesagt-bg: #FDECEC; --status-abgesagt-fg: #D23B3B;

  --radius-md: 10px;
  --radius-lg: 16px;
  --radius-pill: 999px;
  --shadow-card: 0 2px 8px rgba(12,12,20,0.06);
  --shadow-hover: 0 8px 24px rgba(12,12,20,0.12);
  --shadow-modal: 0 18px 48px rgba(12,12,20,0.3);
  --ease: cubic-bezier(0.22,1,0.36,1);
}

* { box-sizing: border-box; }
body {
  margin: 0;
  font-family: 'Hanken Grotesk', system-ui, sans-serif;
  background: var(--cream);
  color: var(--text-1);
}
h1, h2, h3, .headline {
  font-family: 'Archivo', system-ui, sans-serif;
  font-weight: 800;
  letter-spacing: -0.01em;
  margin: 0;
}
button { font-family: inherit; }
